var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercardinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 28"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FF5F00",
  d: "M17.306 6.329h9.393V21.67h-9.393z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EB001B",
  d: "M18.273 14A9.74 9.74 0 0 1 22 6.332a9.756 9.756 0 1 0 0 15.341 9.74 9.74 0 0 1-3.726-7.671"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F79E1B",
  d: "M36.9 20.687v-.845h.17v-.175h-.404v.175h.16v.845zm.785 0v-1.02h-.122l-.143.728-.143-.728h-.122v1.02h.088v-.772l.133.663h.092l.132-.663v.772zm.1-6.686a9.756 9.756 0 0 1-15.786 7.669 9.756 9.756 0 0 0 0-15.341 9.756 9.756 0 0 1 15.786 7.669z"
}))));
export default SvgMastercardinline;